import { Accordion, Card } from 'react-bootstrap';

export default ({ title, itemsComponent, active = false }) => {
  return (
    <>
      <Accordion defaultActiveKey={(active && '0') || false}>
        <Card>
          <Accordion.Toggle as={Card.Header} className="accordionHeader" eventKey="0">
            <span className="font-weight-bold text-primary">{title.toUpperCase()}</span>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>{itemsComponent}</Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </>
  );
};
